namespace Portico.Services {

	import pme = Portico.Models.Enterprise;
	import ps = Portico.Services;
	import psga = apigateway.client;
	import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

	export interface IStateOptions extends angular.ui.IStateOptions {
		returnTo?: string;
	}

    export interface IIntakeService {
		getIntakeLayout: (programId: number, intakeLayoutId: number) => angular.IPromise<pme.IntakeLayout>;
		hcpIntake: (patientIntakeRequestModel: pme.EnrollRequestModel) => angular.IPromise<psgm.HcpIntakeResponseModel>;
		isHcpIntakeAllowed(patient: pme.Patient): angular.IPromise<psgm.IsHcpIntakeAllowedResponseModel>;
		patientIntake: (patientIntake: pme.EnrollRequestModel, closeIntake?: boolean, programId?: string | number ) => angular.IPromise<psgm.IntakePatientIntakeDefaultResponseData>;
    }

    @Service('app', 'intakeService')
	@Inject('$q', 'dataService', 'IntakeV1Api', 'EdgeIntakeApi')
    export class IntakeService implements IIntakeService {
        constructor(
            private $q: angular.IQService,
			private dataService: ps.IDataService,
			private intakeV1LayoutApi: psga.IntakeV1Api,
			private edgeIntakeApi : psga.EdgeIntakeApi
        ) { }

		getIntakeLayout(programId: number, intakeLayoutId: number): angular.IPromise<pme.IntakeLayout> {
			return this.$q.when(this.intakeV1LayoutApi.layoutGetByProgramId(intakeLayoutId.toString(), '', '').then((response: any) => {
				const promises: angular.IPromise<any>[] = [
					this.$q.when(this.intakeV1LayoutApi.layoutSectionGet(intakeLayoutId.toString(), '', '').then((response2: any) => {
						response.data.data.layoutSections = response2.data.data;
						return response2.data.data;
					})),
					this.$q.when(this.intakeV1LayoutApi.layoutSurveyGet(intakeLayoutId.toString(), '', '').then((response2: any) => {
						response.data.data.surveyIds = response2.data.data;
						return response2.data.data;
					}))
				];

				return this.$q.all(promises).then(() => {
					return new pme.IntakeLayout(response);
				});
            }));
		}

		hcpIntake(patientIntakeRequestModel: pme.EnrollRequestModel) {
			const temp = new pme.EnrollRequestModel(patientIntakeRequestModel);
			const sourceId = this.dataService.getEnvironmentId('source-id');
			const accountUpsearchRequestModel = temp.mapToEnterpriseCoordinatorAccountUpsearchRequestModel(sourceId);

			const request = {
				patientAccountUpsearch: accountUpsearchRequestModel
			} as psgm.HcpIntakeRequestModel;

			return this.$q.when(this.edgeIntakeApi.intakeHcpIntake(request).then((response) => {
				return response.data.data;
			}));
		}

		isHcpIntakeAllowed(patient: pme.Patient) {
			const isIntakeAllowedRequest = {
				firstName: patient.firstName,
				lastName: patient.lastName,
				zip: patient.addresses[0].zip,
				gender: patient.gender,
				dateOfBirth: moment(patient.dateOfBirth)
			} as psgm.IsHcpIntakeAllowedRequestModel;

			return this.$q.when(this.edgeIntakeApi.intakeIsHcpIntakeAllowed(isIntakeAllowedRequest).then((response) => {
				return response.data.data;
			}));
		}

		patientIntake(patientIntake: pme.EnrollRequestModel, closeIntake?: boolean, programId?: string | number) {
			const temp = new pme.EnrollRequestModel(patientIntake);
			const sourceId = this.dataService.getEnvironmentId('source-id');
			const accountUpsearchRequestModel = temp.mapToEnterpriseCoordinatorAccountUpsearchRequestModel(sourceId);

			const request = {
				patientAccountUpsearch: accountUpsearchRequestModel,
				closeIntake
			} as psgm.PatientIntakeRequestModel;

			return this.$q.when(this.edgeIntakeApi.intakePatientIntake(request, programId.toString()).then((response) => {
				return response.data.data; 
			}));
		}
    }
}